/**
 * Tracks Vue event-bus subscriptions on the component and tears them down in
 * beforeDestroy, so handlers don't accumulate across mount/unmount cycles.
 *
 * Usage in a component:
 *
 *   import { BusListenersMixin } from '@/mixins/BusListenersMixin';
 *   ...
 *   mixins: [BusListenersMixin],
 *   created() {
 *     this.subscribeBus(EventBus, 'some-event', this.onSomeEvent);
 *     this.subscribeBus(bus, 'another-event', () => this.refresh());
 *   },
 *
 * The mixin's created()/beforeDestroy() hooks run alongside the component's
 * own (Vue 2 merges lifecycle hooks; mixin hooks run first). No need to call
 * cleanup manually.
 */
export const BusListenersMixin = {
  created() {
    this.$_busBindings = [];
  },
  beforeDestroy() {
    (this.$_busBindings || []).forEach(({ bus, event, handler }) => bus.$off(event, handler));
    this.$_busBindings = [];
  },
  methods: {
    subscribeBus(bus, event, handler) {
      if (!this.$_busBindings) this.$_busBindings = [];
      bus.$on(event, handler);
      this.$_busBindings.push({ bus, event, handler });
    },
  },
};
